import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef
} from '@angular/material/dialog';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { DialogData } from 'src/app/shared/purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import { WarehouseService } from 'src/app/home/services/warehouse.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-add-implant-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-implant-modal.component.html',
  styleUrls: ['./add-implant-modal.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})
export class AddImplantModalComponent {
  public dialogData: any;

  public productDetails: any;

  public updatedProducts = {
    product_id: "",
    expiry_date: "",
    batch_no: "",
    rfid: "",
    rate: "",
  };

  public productSearchInput: string = "";
  public searchProductResults = [];
  public encodedProductSearchInput: string = "";

  public isSearch = false;

  public serverErrorMessage: string = "";

  constructor(
    public warehouseService: WarehouseService,
    public dialogRef: MatDialogRef<AddImplantModalComponent>,
    public dialog: MatDialog,
    public location: Location,
    public router: Router,

    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    // this.getImplantDetails();
  }

  // getImplantDetails(){
  //   this.warehouseService.getImplantDetails(this.dialogData.storeId, this.dialogData.implantId).subscribe((res)=>{
  //     if (res.data) {
  //       this.implantDetails = res.data;
  //     }
  //   });
  // }

  onProductSearch(event){
    if (this.productSearchInput !== "") {
      // this.isSearch = true;
      let popupDiv = document.getElementById("search-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation()
        this.closePopupOutside("search-dropdown");
      }

      this.encodedProductSearchInput = encodeURIComponent(this.productSearchInput);

      this.warehouseService.searchProducts(this.encodedProductSearchInput).subscribe((res)=>{
        if(res.data){
          this.searchProductResults = res.data.data;
        }
      })
    }
  }
  onProductFocus(event){
    if (this.productSearchInput !== "") {
      let popupDiv = document.getElementById("search-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation()
        this.closePopupOutside("search-dropdown");
      }
    }
  }

  onSelectProduct(event: Event, productId: string, productName: string){
    this.productSearchInput = productName;

    let popupDiv = document.getElementById("search-dropdown");
    popupDiv.classList.remove("active");

    this.warehouseService.getProductDetails(productId).subscribe((res)=>{
      if (res.data) {
        this.productDetails = res.data;
      }
    })
  }
 
  addProduct(formData: any){
    formData.product_id = this.productDetails?.id;
    this.warehouseService.addProducts(this.dialogData.warehouseId, formData).subscribe((res)=>{
      if (res.data) {
        this.dialogRef.close(true);
      }
    },(errorResponse)=>{
      if (errorResponse) {
        this.serverErrorMessage = errorResponse.error.message;        
      }
    })
  } 

  onClose(): void {
    this.dialogRef.close();
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);
    let productSearchInput = document.getElementById("product-search--input");

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target) &&
        !productSearchInput.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
}
